<header class="bg-primary" *ngIf="headerUiState$ | async as headerUiState">
	<div class="container-lg pb-2">
		<nav class="navbar navbar-expand-lg navbar-dark">
			<div class="d-flex mr-4">
				<a class="navbar-brand" href="/">
					<img
						style="max-width: 200px; max-height: 40px"
						[src]="config.assets.mainLogo"
						alt="NorthstarMLS"
					/>
				</a>
				<ul class="align-self-center navbar-nav mr-auto text-capitalize font-italic fw-bold">
					<a class="text-secondary nav-link" href="/"><li class="nav-item">Add/Edit</li></a>
				</ul>
			</div>
			<button
				(click)="toggleNavbar()"
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>

			<div
				class="collapse navbar-collapse justify-content-between"
				id="navbarSupportedContent"
				[ngClass]="headerUiState.expandNavbar ? 'show d-flex' : ''"
			>
				<ul *ngIf="homepageLink$ | async as links" class="navbar-nav mr-auto text-capitalize">
					<li *ngFor="let link of links" class="nav-item">
						<a
							*ngIf="link.externalLinkIND === 'Y'; else internalLink"
							[href]="link.uRL"
							[ngbTooltip]="link.linkDESCR || null"
							class="nav-link"
							target="_blank"
							>{{ link.linkName }}</a
						>
						<ng-template #internalLink>
							<a
								*ngIf="link?.uRL?.split('#') as urlParts"
								[fragment]="urlParts[1]"
								[ngbTooltip]="link.linkDESCR || null"
								[routerLink]="urlParts[0]"
								class="nav-link"
								>{{ link.linkName }}</a
							>
						</ng-template>
					</li>
				</ul>
				<nstar-session
					*ngIf="session$ | async"
					[buttons]="userWidgetButtons"
					[hideLoginAs]="false"
					class="align-self-center"
					id="session"
				></nstar-session>
			</div>
		</nav>
		<nav class="navbar navbar-dark">
			<div class="collapse navbar-collapse show">
				<app-home-header-search></app-home-header-search>
			</div>
		</nav>
	</div>
</header>
